import { cn } from '../../lib/cn.ts';

/** A shimmering placeholder block. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('skeleton rounded-xl', className)} aria-hidden="true" />;
}

/** A grid of card-shaped skeletons for the gallery loading state. */
export function SkeletonGrid({ count = 12, columnsClass }: { count?: number; columnsClass?: string }) {
  return (
    <div className={cn('grid gap-4', columnsClass ?? 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4')}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="aspect-square" />
      ))}
    </div>
  );
}
